import * as React from "react";
import * as d3 from "d3";

export const PieChart = (props) => {
  const height = 200;
  const width = 200;

  const pie = d3.pie()(props.data.map((x) => x.count));

  return (
    <div className="chart-wrappers-column">
      <h4>{props.title}</h4>
      <svg height={height} width={width}>
        <g transform={`translate(${width / 2},${height / 2})`}>
          <Slice
            pie={pie}
            data={props.data}
            colors={props.data.map((x) => x.color)}
          />
        </g>
      </svg>
    </div>
  );
};

const Slice = (pieProps) => {
  let { pie, colors, data } = pieProps;
  // noinspection JSVoidFunctionReturnValueUsed
  const arc = d3.arc().innerRadius(0).outerRadius(100);

  return pie.map((slice, index) => {
    const sliceColor = colors[index] || "#000";

    return (
      <>
        <path d={arc(slice)} strokeWidth="2" stroke="white" fill={sliceColor}>
          <title style={{ background: "black" }}>
            {data[index].orgName} {data[index].count}
          </title>
        </path>
      </>
    );
  });
};
